export default {
    gridSize: 64,
    uiScale: 2,
    debug: false,
    // soundVolume: 0.05,
    // musicVolume: 0.03,
    soundVolume: 1,
    musicVolume: 0.6,
}